module.exports = __webpack_public_path__ + "img/23.b104d974.jpg";